module.exports = __webpack_public_path__ + "static/media/science_hero_mobile.c5dc65ee.png";